import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { BaseFormComponent } from 'src/app/widgets/global/BaseFormComponent';

// ngx-gallery removed (incompatible with Angular 19) - stub types
export class NgxGalleryOptions { constructor(opts?: any) { Object.assign(this, opts); } }
export class NgxGalleryImage { constructor(opts?: any) { Object.assign(this, opts); } }
export enum NgxGalleryAnimation { Slide = 'slide' }

@Component({
  standalone: false,
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss']
})

export class ReviewComponent extends BaseFormComponent {

  pricingModels: Map<string, string> = new Map<string, string>([
    ['free', 'Free Admission'],
    ['paid', 'Paid Admission']
  ]);

  ocurrenceLabels: Map<string, string> = new Map<string, string>([
    ['OccursBetween', 'Occurs Between'],
    ['OnceOff', 'Once Off'],
  ]);

  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];

  onceOffDateFormatted: string;
  dateStartFormatted: string;
  dateEndFormatted: string;

  dateOptions = { weekday: 'short', day: "2-digit", month: "2-digit", year: "numeric" };

  @Input() vm: any;

  @Output() editInfoEvent = new EventEmitter();

  constructor() {
    super();
  }

  ngOnInit() {
    this.galleryOptions = [
      {
        width: '600px',
        thumbnailsColumns: 3,
        thumbnailsRows: 2,
        thumbnailMargin: 2, thumbnailsMargin: 2,
        "thumbnailsPercent": 30, "imagePercent": 80,
        imageAnimation: NgxGalleryAnimation.Slide,
        "imageDescription": true
      },
      // max-width 800
      { "breakpoint": 500, "width": "300px", "height": "300px", "thumbnailsColumns": 3 },
      // max-width 400
      { "breakpoint": 300, "width": "100%", "height": "200px", "thumbnailsColumns": 2 }
    ];

    // Set Formatted dates
    // let dateOptions = { day: "2-digit", month: "2-digit", year: "numeric" };
    // this.onceOffDateFormatted = this.vm.detailVm.onceOffDate ? new Date(this.vm.detailVm.onceOffDate).toLocaleDateString("en-IE", dateOptions) : "";
    // this.dateStartFormatted = this.vm.detailVm.dateStart ? new Date(this.vm.detailVm.dateStart).toLocaleDateString("en-IE", dateOptions) : "";
    // this.dateEndFormatted = this.vm.detailVm.dateEnd ? new Date(this.vm.detailVm.dateEnd).toLocaleDateString("en-IE", dateOptions) : "";

    this.vm.detailVm.eventDates.sort((a: Date, b: Date) => {
      return a.getTime() - b.getTime();
    });

  }

  getPricingModelViewValue(value) {
    if (value)
      return this.pricingModels.get(value);
    else
      return "";
  }

  getOccurrenceLabel(value) {
    if (value)
      return this.ocurrenceLabels.get(value);
    else
      return "";
  }

  getValueOrDefault(value: any) {
    if (!value)
      return '';

    return value;
  }

  getCategoriesToReviewScreen(categories: any) {
    let categoriesName = [];

    if (categories) {
      categories.forEach(category => {
        switch (category) {
          case 'ComedyEvent': {
            categoriesName.push('Comedy');
            break;
          }
          case 'ChildrensEvent': {
            categoriesName.push('Children\'s');
            break;
          }
          case 'DanceEvent': {
            categoriesName.push('Dance');
            break;
          }
          case 'ExhibitionEvent': {
            categoriesName.push('Exhibitions');
            break;
          }
          case 'FoodEvent': {
            categoriesName.push('Food');
            break;
          }
          case 'EducationEvent': {
            categoriesName.push('Education');
            break;
          }
          case 'LiteraryEvent': {
            categoriesName.push('Literary');
            break;
          }
          case 'MusicEvent': {
            categoriesName.push('Music');
            break;
          }
          case 'SportsEvent': {
            categoriesName.push('Sport and Outdoors');
            break;
          }
          case 'TheaterEvent': {
            categoriesName.push('Theatre');
            break;
          }
          case 'VisualArtsEvent': {
            categoriesName.push('Visual Arts');
            break;
          }
        }
      });
    }

    return categoriesName;
  }

  editFormInfo(index: Number) {
    this.editInfoEvent.emit({
      value: index
    });
  }

}

export interface Pricing {
  value: string;
  viewValue: string;
}